export default {
  message: {
    assetDistribution: "Asset Distribution",
    fixedReturn: "Fixed return",
    trust: "Trust",
    summary: "Summary",
    creditCard: "Credit Card",
    cashMangement: "Cash Management",
    othersAssets: "Others Assets",
    myassetDistribution: "My Asset Distribution",
    elite: "Elite Privilege Inherited Plan",
    signature: "Signature Pro Wealth Management Plan",
    timelessVenture: "Timeless Venture Capital Fund",
    plan: "Plan",
    planName: "Plan name",
    newPlan: "New plan",
    updatePlan: "Update plan",
    subscriptedPlan: "Subscripted plans",
    subscriptedPlanEN: "Subscripted plans (en)",
    subscriptedPlanZH: "Subscripted plans (zh)",
    customerCode: "Customer Code",
    currency: "Currency",
    validDate: "Valid Date",
    expiryDate: "Expiry Date",
    balanceAmount: "Balance Amount",
    expectedAnnualReturn: "Projected Annualized Distribution Rate",
    actualAnnualReturn: "Actual Annualized Distribution Rate(monthly updated)",
    beneficiary: "Beneficiary",
    beneficiaryDeath: "Beneficiary After Death",
    details: "Details",
    overview: "Overview",
    totalConFromEffectiveDate:
      "Total net contributions from the effective date of the account",
    totalConTransInAssets: "Total contributions/Transferred assets",
    totalWithTransOutAssets: "Total withdrawal/Transfer-out assets",
    profitorLossFromEffectiveDate:
      "Investment profit/loss from the effective date of the account",
    accountBalance: "Account Balance",
    accountReturns: "Account Returns",
    quarterFundOverview: "Quarterly Fund Overview",
    notifications: "Notifications",
    addNotifications: "Add notification",
    newNotifications: "New notification",
    date: "Date",
    subject: "Subject",
    detail: "Detail",
    contactUs: "Contact Us",
    agentNo: "Agent no.",
    lastUpdate: "Last Updated",
    back: "Back",
    hkd: "$",
    customer: "Customer",
    customerName: "Customer name",
    addCustomer: "Add customer",
    newCustomer: "New customer",
    updateCustomer: "Edit customer",
    profile: "Profile",
    logout: "Log Out",
    add: "Add",
    confirm: "Confirm",
    update: "Update",
    cancel: "Cancel",
    name: "Name",
    email: "Email",
    content: "Content",
    send: "Send",
    gender: "Gender",
    phone: "Phone",
    dateOfBirth: "Date of birth",
    residentialAddress: "Residential address",
    corrAddress: "Correspondence address",
    confirmPwd: "Confirm password",
    resetPwd: "Reset password",
    No: "No.",
    nickName: "Name",
    balance: "Balance",
    returns: "Returns",
    selectFile: "Select file",
    user: "User",
    staff: "Staff",
    addUser: "Add user",
    newUser: "New user",
    updateUser: "Edit user",
    username: "Username",
    role: "Role",
    password: "Password",
    agentNumber: "Agent No.",
    createdAt: "Created Date",
    goLogin: "Please login again.",
    USD: "USD ",
    HKD: "HKD ",
    EUR: "EUR ",
    RMB: "RMB ",
    male: "male",
    female: "female",
    edit: "Edit",
    pwdError: "The two passwords you entered did not match.",
    sendSuccess: "Send successfully.",
    errorMsg: "Error, please check and try again.",
    editPwd: "Reset Password",
    agent: "Agent",
    clickHere: "Click here",
    signIn: "Sign in",
    goSignIn: "Sign In ?",
    forgotPwd: "Forgot password ?",
    partnerOf: "Partner Of:",
    checkEmail: "Send successfully, Please check your email.",
    checkEmail2: "An activation email has been sent to ",
    checkEmail3: " , Please check the mailbox.",
    checkEmail4: "An email has been sent to ",
    accountError: "Invalid username or password. Please try again.",
    oldPwd: "Old Password",
    oldPwdErrorMsg: "Invalid old password. Please try again.",
    approvalUser: "The user approval",
    pendingApproval: "Pending approval",
    approved: "Approved",
    errorDel: "Delete failed. Please try again.",
    delete: "Delete",
    newPwd: "New password",
    newRePwd: "Confirm new password",
    setPwd: "Send successfully.",
    planTemplate: "Plan Template",
    addPlanTemplate: "Add plan template",
    planTemplateZH: "Plan Template(zh)",
    planTemplateEN: "Plan Template(en)",
    interestRate: "Interest Rate(%)",
    dividendPeriod: "Dividend Period(month)",
    length: "Plan Period(month)",
    manageFee: "Manage Fee(%)",
    managePeriod: "Manage Period(month)",
    newPlanTemplate: "New plan template",
    updatePlanTemplate: "Edit plan template",
    createSuccess: "Created success",
    updateSuccess: "Updated success",
    deleteSuccess: "Delete success",
    dividendMode: "Dividend Mode",
    dividend: "Dividend",
    periods: "Periods",
    dividendDate: "Dividend date",
    interestRate1: "Interest Rate",
    interest: "Interest",
    manageFee1: "Manage fee",
    interest1: "Interest",
    grossInterest: "Gross Interest",
    accumulated: "Accumulated",
    rolloverAmount: "Rollover Amount",
    status: "Status",
    capital: "Capital",
    chooseTemplate: "Choose plan template",
    dividendApproval: "Distribution Approval",
    simple: "Simple",
    compound: "Compound",
    halfYearly: "Half Yearly",
    onHold: "On hold",
    pending: "Pending",
    approve: "Approve",
    reject: "Reject",
    rejected: "Rejected",
    issued: "Issued",
    expired: "Expired",
    complete: "Complete",
    updateDividend: "Edit dividend",
    submit: "Submit",
    clientCode: "Client code",
    clientName: "Client name",
    must_be_number: "must be a number",

    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    enterCurrentPassword: "Enter current password",
    enterNewPassword: "Enter new password",
    confirmNewPasswordPlaceholder: "Confirm new password",
    updatePassword: "Update Password",
    clear: "Clear",
    error: "Error",
    success: "Success",
    passwordMismatch: "New password and confirm password do not match",
    passwordLengthError: "Password must be at least 6 characters long",
    passwordUpdateSuccess: "Password updated successfully",
    currentPasswordIncorrect: "Current password is incorrect",
    passwordUpdateFailed: "Failed to update password",
    passwordUpdateError: "An error occurred while updating password",
    searchCustomer: "Search by name, code, username, email or phone",
    clearSearch: "Clear Search",
    fixedTermStatement: "Statement of Responsibility Regarding Fixed-Term Arrangements: The trust displayed on this account is an irrevocable trust established at the request of the Settlor. Regarding the fixed-term arrangement involved (the \"Fixed-Term Arrangement\"), the Settlor has, after due consideration, independently elected to allocate the relevant Trust Assets into an arrangement possessing a fixed term, liquidity restrictions, and/or early exit restrictions, and acknowledges that such arrangement may involve management, holding, allocation, or execution by independent third-party institutions pursuant to their own legal and commercial terms. The Settlor further confirms that once the relevant assets are allocated to the aforementioned arrangement pursuant to their explicit written instructions, they shall be governed by applicable transaction documents, relevant third-party arrangement documents, and/or other legally binding instruments, and are not unilaterally controlled by the Trustee, nor may they be unilaterally terminated, withdrawn, modified, or exited early by the Trustee at its discretion.\nDuring the fixed term, any request for early redemption, early exit, asset transfer, trust termination, modification, or distribution (if any) shall be subject to this Trust Deed, these Terms, relevant third-party arrangement terms, and applicable laws, and may result in losses, penalties, restricted liquidity, impairment of value, or other adverse consequences due to early disposition. The Settlor acknowledges and accepts such risks. In processing any such requests, the Trustee shall have the right to prudently consider relevant factors in accordance with the Trust Deed, relevant transaction arrangements, third-party constraints, and its duties as Trustee, including but not limited to the preservation of Trust Assets, the overall interests of the beneficiaries, existing legal obligations, and potential risks and consequences arising under the relevant arrangements. The Settlor acknowledges that any projected annualized distribution rate (if any) under the Fixed-Term Arrangement is provided by the relevant independent third party, is for illustrative purposes only, and does not constitute any warranty, promise, or guarantee by the Trustee regarding returns, performance, or results. The Trustee solely performs administrative and custodial duties in accordance with the Trust Deed and does not act as an investment manager, investment advisor, or guarantor of returns. Unless otherwise explicitly agreed, the relevant projected annualized distribution rate (where applicable) has reflected and been deducted in advance of the custody and administrative fees charged annually by the Trustee based on the total value of the Trust Assets. These Terms should be read in conjunction with the Master Trust Deed; in the event of any inconsistency, the same shall be interpreted in accordance with the Master Trust Deed and applicable laws, and, to the extent applicable, these Terms shall fully reflect the Settlor's explicit instructions and the original intent of all parties regarding the Fixed-Term Arrangement.",
  },

  lang: {
    hi: "Hi",
    total_balance: "International Offshore Trust Assets",
    total_credit: "Debit Credit Assets",
    currency: "Currency",
    welcome: "Welcome to your trust account",
    total_amount_of_fixed_custody: "Fixed-term Entrusted Assets",
    total_amount_of_current_custody: "Entrusted Assets",
    fixed_custody_account_number: "Fixed-term Entrusted Assets Number",
    current_custody_account_number: "Entrusted Asset Number",
    demand_trust_amount: "Demand deposit trust amount",
    trust_advisor_number: "Trust advisor number",
    trust_account_id: "Trust Account Id",
    total_amount: "Total Amount",
    account_number: "Account Number",
    add_new: "Add New",
    update_card: "Update Card",
    update_summary: "Update Summary",
    create_fixed_trust_account: "Create Fixed trust amount",
    update_fixed_trust_account: "Update Fixed trust amount",
    create_demand_trust_amount: "Create Demand deposit trust amount",
    update_demand_trust_amount: "Update Demand deposit trust amount",
    summary_total_amount: "Total Trust Assets Amount",
    fixed_trust_account_number: "Fixed trust account number",
    demand_deposit_trust_amount_acount_number:
      "Demand deposit trust amount account number",

    credit_card: "Credit Card",
    cash: "Cash",
    fixed_return: "Fixed return",
    fixed_custody: "Fixed-term Entrusted Assets",
    current_custody: "Entrusted Assets",

    card_number: "Card Number",
    expiry_date: "Expiry Date",
    card_holder_name: "Card Holder Name",
    total_credit_limit: "Total Credit Limit",
    used_credit: "Used Credit",
    remaining_limit: "Remaining Limit",

    latest_transactions: "Latest 5 transaction detail",
    just_latest_transactions: "Latest transaction",
    create_transactions: "Create transaction",
    update_transactions: "Update transaction",
    spending_date: "Payment Date",
    deduct_date: "Deduct Date",
    spending_detail: "Payment Details",
    spending_location: "Place Of Payment",
    international_ex_fee: "Local payment amount",
    usd_deduct_amount: "USD Deduct Amount",
    fx_charge_date: "FX Charge Date",
    currency_type: "Currency Type / Amount",

    fixed_custody_number: "Fixed-term Entrusted Assets Number",
    effective_date: "Effective Date",
    maturity_date: "Maturity Date",
    management_currency: "Currency",
    custody_amount: "Entrusted Assets",
    standard_return: "Projected Annualized Distribution Rate",
    beneficiary: "Beneficiary",
    beneficiary_after_death: "Beneficiary After Death",
    note: "Note",
    deposit_withdrawal: "Contribute / Distribute",
    amount: "Net Assets",
    account_balance: "Entrusted Assets Balance",
    initial_deposit: "Initial Trust Principal",
    interest_deposit: "Distribution",
    details: "Detail",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    usd: "USD",
    asset_type: "Asset Type",
    unit: "Unit",
    asset_total: "Asset total/ estimated value",
    others_assets: "Others Assets",
    add_other_asset: "Add Others Assets",
    update_other_asset: "Update Others Assets",
    before_beneficiary: "Before Beneficiary",
    after_beneficiary: "After Beneficiary",
    remark: "Remark",
  },
};
